export default {
  tabs: {
    travel: '行程',
    shaft: '轴体',
  },
  shaftPanel: {
    title: '轴体选择',
    types: {
      CiYuPro: '磁玉轴 PRO',
      CiYuGaming: '磁玉轴 Gaming',
      WanCiWangRgb: '万磁王轴 RGB',
      WanCiWangPom: '万磁王轴 POM',
      WanCiWang: '万磁王轴',
      TianWangEsports: '天王磁轴-电竞版',
      TianWangStandard: '天王磁轴-标准版',
      KailhCiShen: '凯华磁神轴',
      TaiShanGt: '泰山磁轴 GT',
      CiPo: '磁珀轴',
      XingLan: '星岚磁轴',
      LiuLi: '琉璃磁轴',
    },
  },
  calibrationPanel: {
    backToItinerary: '返回行程',
    introTip: '按压单键后四周都环顾到校准更加准确',
    title: '轴体校准',
    instructionPrefix: '点击',
    instructionMiddle: '按钮，将需要校准的按键完全按下；当按键显示',
    instructionSuccess: '绿色则说明该按键校准成功',
    instructionSuffix: '；校准完成后需点击',
    calibrationHint: '现在可以开始将需要校准的按键完全按下',
    startCalibration: '开始校准',
    saveCalibration: '保存校准',
    adaptiveTitle: '自适应校准',
    adaptiveDescription: '根据使用环境和操作习惯自适应校准精度，确保使用稳定性',
    adaptiveWarning: '关闭后，会增加断触和误触发风险',
  },
  keyboardPanel: {
    selectAll: '按键全选',
    invertSelection: '按键反选',
    selectWASD: 'WASD',
    selectAZ: 'A-Z',
    selectionToast: '鼠标右键，取消选择',
  },
  arcGaugeSlider: {
    title: '按键级数示意',
    calibrate: '校准',
    referenceOnly: '示意非精确显示，仅供参考',
  },
  itineraryTrigger: {
    triggerTravel: '触发行程',
    initialTriggerTravel: '初始触发行程',
    rtMode: 'RT 模式',
    rtModeTooltip: '可以选择虚拟键盘上的任意按键设置 RT 模式',
    rtModeDescription: '根据按下或松开按键的意图，动态地调整触发和重置行程',
    continuousTrigger: '连续快速触发',
    continuousTriggerTooltip: '开启 RT 模式后可设置连续快速触发',
    continuousTriggerDescription:
      '启用时，快速触发在按键完全抬起后才停用。禁用时，快速触发在按键抬起到触发键程后停用。',
  },
  bottomDeadZone: {
    title: '触底死区',
    description: '自动限制底部抬起重置行程，以提高稳定性，避免断触发生',
  },
  deadZone: {
    title: '死区设置',
    description: '顶部死区-减少误触，底部死区-减少断触。',
    top: '顶部',
    bottom: '底部',
  },
  rtSensitivityTrigger: {
    triggerSensitivity: 'RT触发灵敏度',
    triggerTooltip:
      '按压超过设定的灵敏度数值时触发；松开按键超过重置值后，重新按下设定的灵敏度继续触发',
    linkedMode: '对等模式',
    unlinkedMode: '不对等模式',
    resetSensitivity: 'RT重置灵敏度',
    resetTooltip: '松开超过设定的灵敏度数值时重置',
    switchKey: 'RT切换键',
    custom: '自定义',
    precisionAdjust: 'RT 精度调节',
  },
}
